import {
    Circle,
    HorizontalScroll,
    IconLandlineRegular,
    IconMultideviceRegular,
    IconOpticalFiberRegular,
    IconTvContentRegular,
    skinVars,
    SnapCard,
    useWindowSize,
} from '@telefonica/mistica';
import React from 'react';
import './index.scss';
import { Badge } from '@telefonica/mistica';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../translations/i18n';
import { useDispatch } from 'react-redux';
import { showStopper } from '../../utils/store/features/user';
import { managementEnvironment } from '../../utils/dataTransformation/environments';
import { Device } from '../../models/Devices';
import { saveDevices } from '../../pages/home/devices/devicesStorage';

export interface OtherServicesSectionData {
    dataTab: any;
    BillingCycle?: any;
    closing?: any;
    devices?: Device[];
    netflix?: boolean;
}

const OtherServicesSection: React.FC<OtherServicesSectionData> = ({
    dataTab,
    BillingCycle,
    closing,
    devices,
    netflix,
}: OtherServicesSectionData) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const consumptionsDisabled = managementEnvironment().REACT_APP_STOPPER_CONSUMPTIONS_DISABLED;
    const size = useWindowSize();

    const sendToNative = (url: string) => {
        if (url === '/phone') {
            if (consumptionsDisabled) {
                dispatch(showStopper());
            } else {
                const dataTabStorage = dataTab;
                dataTabStorage.BillingCycle = BillingCycle;
                dataTabStorage.closing = closing;
                localStorage.setItem('storage', JSON.stringify(dataTabStorage));
                navigate(url + '?productPsId=' + dataTab.productPsId);
            }
        } else if (url === '/fiber') {
            const dataTabStorage = dataTab;
            dataTabStorage.BillingCycle = BillingCycle;
            dataTabStorage.closing = closing;
            navigate(url + '?productId=' + dataTab.productId);
        } else if (url === '/devices') {
            saveDevices(devices || []);
            navigate(url);
        }
    };

    const eventToNavigateNetflix = () => {
        window?.top?.postMessage(
            {
                id: 'ajx4',
                action: 'navigateTo',
                details: '/area-privada/?section=entertainment&product=netflix',
            },
            '*',
        );
    };

    return (
        <div className='other-services-section'>
            <div className='other-services-section__cards'>
                <HorizontalScroll>
                    <div
                        className='other-services-section__cards-container'
                        style={{ width: devices ? (size.width >= 768 ? '100%' : 'auto') : '100%' }}
                    >
                        <div
                            className='other-services-section__cards-container__card'
                            style={{
                                width: devices
                                    ? size.width >= 1024
                                        ? '100%'
                                        : size.width >= 768
                                        ? '100%'
                                        : '152px'
                                    : '100%',
                            }}
                            onClick={() => sendToNative('/fiber')}
                        >
                            <SnapCard
                                icon={
                                    <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                        <IconOpticalFiberRegular color={skinVars.colors.brand} size={24} />
                                    </Circle>
                                }
                                title={t('fiber')}
                            ></SnapCard>
                        </div>
                        {netflix && (
                            <div
                                className='other-services-section__cards-container__card'
                                style={{
                                    width: devices
                                        ? size.width >= 1024
                                            ? '100%'
                                            : size.width >= 768
                                            ? '100%'
                                            : '152px'
                                        : '100%',
                                }}
                                onClick={() => eventToNavigateNetflix()}
                            >
                                <SnapCard
                                    icon={
                                        <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                            <IconTvContentRegular color={skinVars.colors.brand} size={24} />
                                        </Circle>
                                    }
                                    title={t('Entertainment')}
                                ></SnapCard>
                            </div>
                        )}
                        {devices?.length! > 0 && (
                            <div
                                className='other-services-section__cards-container__card'
                                style={{
                                    width: devices
                                        ? size.width >= 1024
                                            ? '100%'
                                            : size.width >= 768
                                            ? '100%'
                                            : '152px'
                                        : '100%',
                                }}
                                onClick={() => sendToNative('/devices')}
                            >
                                <SnapCard
                                    icon={
                                        <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                            <IconMultideviceRegular color={skinVars.colors.brand} size={24} />
                                        </Circle>
                                    }
                                    title={t('devicesExplore')}
                                ></SnapCard>
                            </div>
                        )}
                        <div
                            className='other-services-section__cards-container__card'
                            style={{
                                width: devices
                                    ? size.width >= 1024
                                        ? '100%'
                                        : size.width >= 768
                                        ? '100%'
                                        : '152px'
                                    : '100%',
                            }}
                            onClick={() => sendToNative('/phone')}
                        >
                            <SnapCard
                                icon={
                                    <div>
                                        <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                            <div className='other-services-section__cards-container__card-circle'>
                                                {dataTab.extraSum > 0 && (
                                                    <div className='other-services-section__cards-container__card-circle-badge'>
                                                        <Badge></Badge>
                                                    </div>
                                                )}
                                                <IconLandlineRegular color={skinVars.colors.brand} size={24} />
                                            </div>
                                        </Circle>
                                    </div>
                                }
                                title={t('permanent')}
                            ></SnapCard>
                        </div>
                    </div>
                </HorizontalScroll>
            </div>
        </div>
    );
};

export default OtherServicesSection;
